module.exports = __webpack_public_path__ + "static/media/s11.f2a3acbf.jpg";